export default __webpack_public_path__ + "8266ba26d40e9a7b1f215f5926b8ea78.png";